import BossModel from "@/models/BossModel";
import Agent from '@/models/Agent/Agent';
import AddressType from "@/models/AddressType/AddressType";

export default class Address extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'agent/address';

    /**
     *
     * @type {string}
     */
    static entity = 'agentAddresses';

    static fields() {
        return {
            id: this.number(null).nullable(),
            agent_id: this.number(null).nullable(),
            agent_address_type_id: this.number(null).nullable(),
            firstname: this.attr(null),
            lastname: this.attr(null),
            address: this.attr(null),
            zip_code: this.attr(null),
            city: this.attr(null),
            telephone: this.attr(null),
            notes: this.attr(null),
            email: this.attr(null),
            fax: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            agent: this.belongsTo(Agent, 'agent_id'),
            type: this.belongsTo(AddressType, 'agent_address_type_id'),
        }
    }

    /**
     *
     * @returns {boolean|*}
     */
    Agent() {
        return this.getRelated('agent');
    }


}
